import { render } from "./CandidateProfileOverview.vue?vue&type=template&id=f449fa9e&scoped=true"
import script from "./CandidateProfileOverview.vue?vue&type=script&lang=js"
export * from "./CandidateProfileOverview.vue?vue&type=script&lang=js"

import "./CandidateProfileOverview.vue?vue&type=style&index=0&id=f449fa9e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f449fa9e"]])

export default __exports__